module.exports = require("npm:react-dom@0.14.6/index.js");